import React from "react";
import styled from "styled-components";
import {
    AssignmentContainer,
    ImportantAssignmentContainer,
    AssignmentCompleteContainer,
    AssignmentUpcomingContainer,
    StatContainer,
    IconContainer,
    InfoPane
} from "../styled_components/containers";
import star from "../assets/star.png";
import calendar from "../assets/calendar.png";
import PlayButton from "../styled_components/play_button";
import game_data from "../../games/game_data";

function AssignmentName(assignment){
    var myname = "";
    let subject = game_data.find(gd => gd.id == assignment.galaxy_id);

    if (assignment.important == 1){
        //myname+= "Important "
    }

    

    if (assignment.galaxy_id == 35){
        var assessment_type = assignment.assessment_type.split("_");
        
        //special ones
        if (assignment.assessment_type == "numberbonds1020"){
            myname += "Number Bonds 10 & 20 assessment";
        }
        else if (assignment.assessment_type == "mtcnetlimited" || assignment.assessment_type == "mtcnetlimited|access"){
            myname+= "MTC Type assessment - 2, 3, 5 & 10 Times Tables"
        }
        else if (assignment.assessment_type == "mtcnetlimited2" || assignment.assessment_type == "mtcnetlimited2|access"){
            myname+= "MTC Type assessment - 2, 3, 4, 5, 8 & 10 Times Tables"
        }
        else if (assignment.assessment_type == "mtcnetlimited3" || assignment.assessment_type == "mtcnetlimited3|access"){
            myname+= "MTC Type assessment - 2, 5 & 10 Times Tables"
        }
        else if (assignment.assessment_type == "mtcnet" || assignment.assessment_type == "mtcnet|access" ){
            myname+= "MTC assessment"
        }
        else if (assignment.assessment_type == "mtc6" || assignment.assessment_type == "mtc6|access" ){
            myname+= "MTC assessment"
        }
        else{
            //parse the assessment_type
            myname += "Year " + assessment_type[0] + " ";
            myname += assessment_type[2];
            if (assessment_type[3] == "ar"){
                myname+= " arithmetic assessment"
            }else if (assessment_type[3] == "re"){
                myname+= " reasoning assessment"
            } else if (assessment_type[3] == "spelling" || assessment_type[3] == "grammar"){
                myname+= " " + assessment_type[3] + " assessment";
            }else{
                myname+= " block assessment";
            }
        }

        
    }else{
        if (assignment.assessment_type != null && assignment.assessment_type.includes("learn")){
            myname+= subject.description + " Learn Homework"
        }else{
            myname+= subject.description + " Battle";
        } 
        
    }

    return myname;
}

function Clash({ assignment, margin, playAssignment }) {

    function Play(){
        console.log(assignment);
        console.log(playAssignment);
        playAssignment(assignment);
    }

    let attempts = 0;
    attempts = assignment.submissions.length;

    let score = 0;
    score = assignment.highest_level_reached;

    let startDate = new Date(assignment.starts_at);
    let date = new Date(assignment.ends_at);

    function formattedDate() {
       // return formattedStartDate();
        //return `${date.getDate()}/${("0" + (date.getMonth() + 1)).slice(-2)}/${date.getFullYear()}`;

        var date_format = '12'; /* FORMAT CAN BE 12 hour (12) OR 24 hour (24)*/
        var d       = date;
        var hour    = d.getHours();  /* Returns the hour (from 0-23) */
        var minutes     = d.getMinutes();  /* Returns the minutes (from 0-59) */
        var result  = hour;
        var ext     = '';
 
        if(date_format == '12'){
            if(hour > 12){
                ext = 'PM';
                hour = (hour - 12);
                result = hour;

                if(hour < 10){
                    result = "0" + hour;
                }else if(hour == 12){
                    hour = "00";
                    ext = 'AM';
                }
            }
            else if(hour < 12){
                result = ((hour < 10) ? "0" + hour : hour);
                ext = 'AM';
            }else if(hour == 12){
                ext = 'PM';
            }
        }
        
        if(minutes < 10){
            minutes = "0" + minutes; 
        }
        
        result = result + ":" + minutes + ' ' + ext; 
        
        console.log(result);
        return result;
        //return `${startDate.getHours()}`;
       // return `${startDate.getDate()}/${("0" + (startDate.getMonth() + 1)).slice(-2)}/${startDate.getFullYear()}`
    }

    function formattedStartDate() {
        var date_format = '12'; /* FORMAT CAN BE 12 hour (12) OR 24 hour (24)*/
        var d       = startDate;
        var hour    = d.getHours();  /* Returns the hour (from 0-23) */
        var minutes     = d.getMinutes();  /* Returns the minutes (from 0-59) */
        var result  = hour;
        var ext     = '';
 
        if(date_format == '12'){
            if(hour > 12){
                ext = 'PM';
                hour = (hour - 12);
                result = hour;

                if(hour < 10){
                    result = "0" + hour;
                }else if(hour == 12){
                    hour = "00";
                    ext = 'AM';
                }
            }
            else if(hour < 12){
                result = ((hour < 10) ? "0" + hour : hour);
                ext = 'AM';
            }else if(hour == 12){
                ext = 'PM';
            }
        }
        
        if(minutes < 10){
            minutes = "0" + minutes; 
        }
        
        result = result + ":" + minutes + ' ' + ext; 
        
        console.log(result);
        return result;
        //return `${startDate.getHours()}`;
       // return `${startDate.getDate()}/${("0" + (startDate.getMonth() + 1)).slice(-2)}/${startDate.getFullYear()}`;
    }

    let todaysDate = new Date();

    function getCurrentDate(){

        return `${todaysDate.getDate()}/${("0" + (todaysDate.getMonth() + 1)).slice(-2)}/${todaysDate.getFullYear()}`;
        }

    let subject = game_data.find(gd => gd.id == assignment.galaxy_id);

    console.log(assignment);

    //Liam - if there is an important task but it's not past the start time then there's no important until start time
    if(assignment.important >= 1 && startDate.getTime() > todaysDate.getTime()){
       assignment.important = false;
	}
    else{
     //assignment.important = true;
	}
    //end

   if(startDate.getTime() > todaysDate.getTime()) //make the assignment grey
   {
    return (
        <AssignmentUpcomingContainer className={margin} style={{width: "800px", height:"200px"}}>
            <h3>{AssignmentName(assignment)}</h3>
            <InfoPane>
                    <StatContainer display="">
                        <IconContainer>
                            
                        </IconContainer>
                        
                    </StatContainer>

                    <StatContainer display="">
                        <IconContainer>
                            
                        </IconContainer>
                       
                    </StatContainer>
                {
                    
                    <DisabledButton disabled={true}>Starts at {formattedStartDate()}</DisabledButton>
                }
            </InfoPane>
        </AssignmentUpcomingContainer>
    );
   }

    else if (assignment.submissions.length > 0 || parseInt(assignment.highest_level_reached) > 0) {
        return (
            <AssignmentCompleteContainer className={margin} style={{width: "800px", height:"200px"}}>
                <h3>{AssignmentName(assignment)}</h3>
                <InfoPane>
                    <StatContainer dark={"#c25e09"}>
                        <IconContainer light={"#e96d0b"}>
                            <img src={star} alt="star-icon" />
                        </IconContainer>
                        <span>Best Result: {score} correct</span>
                    </StatContainer>

                    {/* Attempts */}
                    <StatContainer dark={"#c25e09"}>
                        <span> Attempts: {attempts}</span>
                    </StatContainer>

                   {/* Start Date: */}
                   <StatContainer dark={"#6a4f82"}>
                        <span>Start: {formattedStartDate()}</span>
                    </StatContainer>

                    <StatContainer dark={"#6a4f82"}>
                        <IconContainer light={"#805e9b"}>
                            <img src={calendar} alt="calendar-icon" />
                        </IconContainer>
                        <span>Ends: {formattedDate()}</span>
                    </StatContainer>
                    {
                        subject.playable ?
                            <PlayButton onClick={() => { Play() }}>Play</PlayButton> :
                            <DisabledButton disabled={true}>Download to Play</DisabledButton>
                    }
                </InfoPane>
            </AssignmentCompleteContainer>
        );
    }

    else if (assignment.important == 0) {
        return (
            <AssignmentContainer className={margin} style={{width: "800px", height:"200px"}}>
                <h3>{AssignmentName(assignment)}</h3>
                <InfoPane>
                    <StatContainer dark={"#c25e09"}>
                        <IconContainer light={"#e96d0b"}>
                            <img src={star} alt="star-icon" />
                        </IconContainer>
                        <span>Best Result: {score} correct</span>
                    </StatContainer>

                    {/* Attempts */}
                    <StatContainer dark={"#c25e09"}>
                        <span> Attempts: {attempts}</span>
                    </StatContainer>

                   {/* Start Date: */}
                   <StatContainer dark={"#6a4f82"}>
                        <span>Start: {formattedStartDate()}</span>
                    </StatContainer>

                    <StatContainer dark={"#6a4f82"}>
                        <IconContainer light={"#805e9b"}>
                            <img src={calendar} alt="calendar-icon" />
                        </IconContainer>
                        <span>Due: {formattedDate()}</span>
                    </StatContainer>
                    {
                        subject.playable ?
                            <PlayButton onClick={() => { playAssignment(assignment) }}>Play</PlayButton> :
                            <DisabledButton disabled={true}>Download to Play</DisabledButton>
                    }
                </InfoPane>
            </AssignmentContainer>
        );
    }
    else {
        return (
            <ImportantAssignmentContainer className={margin} style={{width: "800px", height:"200px"}}>
                <h3>{AssignmentName(assignment)}</h3>
                <InfoPane>
                    <StatContainer dark={"#c25e09"}>
                        <IconContainer light={"#e96d0b"}>
                            <img src={star} alt="star-icon" />
                        </IconContainer>
                        <span>Best Result: {score} correct</span>
                    </StatContainer>

                    {/* Attempts */}
                    <StatContainer dark={"#c25e09"}>
                        <span> Attempts: {attempts}</span>
                    </StatContainer>

                   {/* Start Date: */}
                   <StatContainer dark={"#6a4f82"}>
                        <span>Start: {formattedStartDate()}</span>
                    </StatContainer>

                    <StatContainer dark={"#6a4f82"}>
                        <IconContainer light={"#805e9b"}>
                            <img src={calendar} alt="calendar-icon" />
                        </IconContainer>
                        <span>Ends: {formattedDate()}</span>
                    </StatContainer>
                    {
                        subject.playable ?
                            <PlayButton onClick={() => { playAssignment(assignment) }}>Play</PlayButton> :
                            <DisabledButton disabled={true}>Download to Play</DisabledButton>
                    }
                </InfoPane>
            </ImportantAssignmentContainer>
        );
    }
}

export default Clash;

const DisabledButton = styled(PlayButton)`
    background: rgb(128, 128, 128);
    user-select: none;
    background: linear-gradient(
        0deg,
        rgba(128, 128, 128, 1) 0%,
        rgba(143, 143, 143, 1) 100%
    );
    border: 2px solid #7d7d7d;
`;
